export const queryAnnouncementsByCompanyIdIndex = `query QueryAnnouncementsByCompanyIdIndex(
    $companyId: ID!
    $first: Int
    $after: String
  ) {
    queryAnnouncementsByCompanyIdIndex(
      companyId: $companyId
      first: $first
      after: $after
    ) {
        items {
            id
            companyId
            title
            content
            dateCreated
            hide
            userGroups
            thumbnail {
              bucket
              key
              region
            }
            displayGroupSelect
            tags
            pinned
            author
            thumbnailSignedUrl
            publishAt
            expireAt
            viewCount
            updatedAt
          }
          nextToken
    }
  }
  `;
